.#{$namespace}-table {
	position: relative;
	width: 100%;
	// 没传 height 时跟行走；flex 父级 stretch 会把外壳拉成固定高，最后一行被 card overflow 裁掉
	height: max-content;
	box-sizing: border-box;
	font-size: $font-size;
	color: $text-color;
	background: $white-color;

	&__inner {
		width: 100%;
		border-collapse: collapse;
		table-layout: fixed;
	}

	&__header {
		th {
			background: $border-lighter-color;
			font-weight: 600;
			color: $text-primary-color;
		}
	}

	&__cell {
		padding: 10px 12px;
		box-sizing: border-box;
		line-height: 1.5;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-bottom: 1px solid $border-lighter-color;

		// 勾选列收窄内边距，避免 55 宽被挤换行
		&--selection {
			padding-left: 8px;
			padding-right: 8px;
			.#{$namespace}-checkbox {
				margin-right: 0;
			}
		}
	}

	&__row {
		transition: background-color 0.15s;

		&:hover > td {
			background: color-token(primary, light-9);
		}

		&.is-striped > td {
			background: color-token(info, light-9);
		}

		&.is-striped:hover > td {
			background: color-token(primary, light-9);
		}

		// 多选勾中 / 单选当前行：比 hover 稍深一点，翻页回来仍能辨认
		&.is-selected > td,
		&.is-current > td {
			background: color-token(primary, light-8);
		}

		&.is-selected:hover > td,
		&.is-current:hover > td {
			background: color-token(primary, light-7);
		}
	}

	&__empty {
		padding: 32px 12px;
		text-align: center;
		color: $text-placeholder-color;
		font-size: calc($font-size - 1px);
	}

	&.is-border {
		border: 1px solid $border-lighter-color;
		border-radius: 4px;

		.#{$namespace}-table__cell {
			border-right: 1px solid $border-lighter-color;

			&:last-child {
				border-right: none;
			}
		}

		.#{$namespace}-table__header .#{$namespace}-table__cell {
			border-bottom: 1px solid $border-color;
		}
	}
}
